import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";

import ViewBookingLayer from "../../components/booking/ViewBookingLayer";

const ViewBookingPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb
          routePath="/all-bookings"
          routeName="All Bookings"
          title="View Booking Details"
        />

        {/* AddUserLayer */}
        <ViewBookingLayer />
      </MasterLayout>
    </>
  );
};

export default ViewBookingPage;
